import { render, staticRenderFns } from "./ViewCandidatesBody.vue?vue&type=template&id=f77c75aa&scoped=true"
import script from "./ViewCandidatesBody.vue?vue&type=script&lang=ts"
export * from "./ViewCandidatesBody.vue?vue&type=script&lang=ts"
import style0 from "./ViewCandidatesBody.vue?vue&type=style&index=0&id=f77c75aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77c75aa",
  null
  
)

export default component.exports